/**
 * King Living Alert Theme
 *
 * Global alert styling system supporting:
 * - 4 states: error, warning, info, success
 * - Custom background colors and borders
 * - Icon support for each state
 * - Optional close button
 * - Optional link text
 *
 * @override Extends Chakra UI Alert theme
 */

const Alert = {
  parts: ['container', 'icon', 'title', 'description', 'spinner'],
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      px: 4,
      py: 2,
      borderRadius: 'base', // 4px
      border: '1px solid',
      fontSize: 'xs', // 12px
      fontFamily: 'body',
      fontWeight: 'normal',
      lineHeight: '120%', // 1.2
    },
    icon: {
      boxSize: 5, // 20px
      flexShrink: 0,
      mr: 0,
    },
    title: {
      flex: 1,
      minWidth: 0,
      wordBreak: 'break-word',
      fontSize: 'xs', // 12px
      fontFamily: 'body',
      fontWeight: 'normal',
      lineHeight: '120%', // 1.2
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
    },
    description: {
      flex: 1,
      minWidth: 0,
      wordBreak: 'break-word',
      fontSize: 'xs', // 12px
      fontFamily: 'body',
      fontWeight: 'normal',
      lineHeight: '120%', // 1.2
      color: 'brandColors.greyscale90', // rgba(27, 26, 24, 0.90)
    },
  },
  variants: {
    error: {
      container: {
        bg: 'brandColors.errorBG', // #fef2f2
        borderColor: 'brandColors.error', // #9d2a1e
      },
      icon: {
        color: 'brandColors.error', // #9d2a1e
      },
    },
    warning: {
      container: {
        bg: 'brandColors.warningBG', // #fef3e2
        borderColor: 'brandColors.warning', // #d97706
      },
      icon: {
        color: 'brandColors.warning', // #d97706
      },
    },
    info: {
      container: {
        bg: 'brandColors.infoBG', // #e0f2fe
        borderColor: 'brandColors.info', // #0369a1
      },
      icon: {
        color: 'brandColors.info', // #0369a1
      },
    },
    success: {
      container: {
        bg: 'brandColors.successBG', // #e8f4e7
        borderColor: 'brandColors.success', // #2d7831
      },
      icon: {
        color: 'brandColors.success', // #2d7831
      },
    },
  },
  defaultProps: {
    variant: 'info',
  },
};

export default Alert;
